import React, { useState } from 'react';

const faqs = [
  {
    q: 'Quanto tempo richiede il processo completo?',
    a: 'Il processo completo richiede 7–14 giorni: registrazione immediata, 15 minuti per il questionario, consulenza entro 24 ore e certificato entro 5 giorni lavorativi.',
  },
  {
    q: 'La certificazione ESG è riconosciuta internazionalmente?',
    a: 'Sì, la nostra certificazione segue gli standard GRI, SASB e TCFD. È riconosciuta da investitori ESG e accettata per bandi pubblici e contratti enterprise.',
  },
  {
    q: 'Posso certificare progetti in sviluppo o solo quelli completati?',
    a: 'Puoi certificare sia progetti completati che in fase di sviluppo. Per progetti in corso, forniamo una roadmap ESG per implementare le best practices durante lo sviluppo.',
  },
  {
    q: 'Quanto costa la certificazione ESG?',
    a: "Il costo varia in base alle dimensioni dell'azienda e complessità dei progetti. La consulenza iniziale è sempre gratuita e senza impegno. Contattaci per un preventivo personalizzato.",
  },
  {
    q: 'Cosa succede se non passo la valutazione ESG?',
    a: 'Non esistono "bocciature". Ti forniamo sempre un piano d\'azione per migliorare il tuo punteggio ESG e supporto dedicato per implementare le correzioni necessarie.',
  },
  {
    q: 'Il certificato ESG ha una scadenza?',
    a: 'Il certificato è valido 2 anni. Offriamo un processo di rinnovo semplificato e monitoraggio continuo per mantenere sempre aggiornato il tuo status ESG.',
  },
  {
    q: 'Quali tipologie di software possono essere certificate?',
    a: 'Qualsiasi tipologia: web app, mobile, API, SaaS, ERP, sistemi embedded e AI/ML. Il questionario è adattato in base alla categoria del progetto.',
  },
  {
    q: 'Chi rilascia il certificato ufficiale?',
    a: 'Il certificato viene rilasciato da un ente certificatore accreditato, dopo la revisione del questionario e la valutazione del punteggio ESG raggiunto.',
  },
];

export default function FaqPage() {
  const [open, setOpen] = useState(null);

  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <div style={{ background: '#F8F8F6', minHeight: '100vh' }}>
      <style>{`
        .faq-item {
          border-bottom: 1px solid #E0DED6;
          transition: background 0.15s;
        }
        .faq-item:last-child { border-bottom: none; }
        .faq-question {
          width: 100%;
          background: none;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 24px 0;
          text-align: left;
        }
        .faq-question:hover .faq-q-text { color: #1D9E75; }
        .faq-q-text {
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
          line-height: 1.4;
          transition: color 0.15s;
        }
        .faq-q-text.active { color: #1D9E75; }
        .faq-icon {
          flex-shrink: 0;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 1.5px solid #1D9E75;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1D9E75;
          font-size: 18px;
          font-weight: 300;
          transition: background 0.15s, color 0.15s;
          line-height: 1;
        }
        .faq-icon.active {
          background: #1D9E75;
          color: white;
        }
        .faq-answer {
          overflow: hidden;
          max-height: 0;
          transition: max-height 0.3s ease, padding 0.3s ease;
        }
        .faq-answer.open {
          max-height: 300px;
          padding-bottom: 24px;
        }
        .faq-answer p {
          font-size: 15px;
          color: #5C5B55;
          line-height: 1.75;
          margin: 0;
        }
      `}</style>

      {/* Hero */}
      <section style={{ background: 'white', borderBottom: '1px solid #E0DED6', padding: '56px 24px 48px', textAlign: 'center' }}>
        <div style={{ maxWidth: 640, margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#EAF3DE', color: '#3B6D11', borderRadius: 20, padding: '4px 14px', fontSize: 12, fontWeight: 500, marginBottom: 20 }}>
            Hai domande?
          </div>
          <h1 style={{ fontSize: 38, fontWeight: 500, color: '#1a1a1a', lineHeight: 1.2, marginBottom: 16 }}>
            Domande Frequenti
          </h1>
          <p style={{ fontSize: 16, color: '#5C5B55', lineHeight: 1.7, margin: 0 }}>
            Tutto quello che devi sapere sulla certificazione ESG per il tuo software.
            Non trovi la risposta? <a href="/contatti" style={{ color: '#1D9E75', textDecoration: 'none', fontWeight: 500 }}>Contattaci</a>.
          </p>
        </div>
      </section>

      {/* FAQ list */}
      <section style={{ padding: '56px 24px' }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>

          {/* Categories hint */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 40 }}>
            {['Processo', 'Costi', 'Certificazione', 'Tecnico'].map(tag => (
              <span key={tag} style={{ fontSize: 12, fontWeight: 500, padding: '5px 14px', borderRadius: 20, border: '1px solid #C0DD97', color: '#3B6D11', background: '#EAF3DE', cursor: 'default' }}>
                {tag}
              </span>
            ))}
          </div>

          {/* Card wrapper */}
          <div style={{ background: 'white', borderRadius: 12, border: '1px solid #E0DED6', padding: '0 32px' }}>
            {faqs.map((faq, i) => (
              <div key={i} className="faq-item">
                <button className="faq-question" onClick={() => toggle(i)}>
                  <span className={`faq-q-text${open === i ? ' active' : ''}`}>{faq.q}</span>
                  <span className={`faq-icon${open === i ? ' active' : ''}`}>
                    {open === i ? '−' : '+'}
                  </span>
                </button>
                <div className={`faq-answer${open === i ? ' open' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* CTA bottom */}
      <section style={{ padding: '0 24px 72px' }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <div style={{ background: '#1D9E75', borderRadius: 12, padding: '40px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24 }}>
            <div>
              <h3 style={{ fontSize: 20, fontWeight: 500, color: 'white', margin: '0 0 8px' }}>Non hai trovato la risposta?</h3>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)', margin: 0 }}>Il nostro team è a disposizione per qualsiasi domanda.</p>
            </div>
            <a href="/contatti" style={{ display: 'inline-block', background: 'white', color: '#1D9E75', fontWeight: 600, fontSize: 14, padding: '12px 28px', borderRadius: 8, textDecoration: 'none', flexShrink: 0 }}>
              Contattaci →
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
